import styled from "styled-components";

function TextHome1(){
    return(
        <TextSpam>
            <h2>Queremos te desafiar</h2>
                    Nada que vem muito fácil dura muito tempo. Por isso, acreditamos que a verdadeira diversão se encontra em toda aquela estratégia que você montou com seus amigos pra matar aquele <b>Boss</b> que ninguém mais conseguiu ou naquela jornada que você embarcou para conseguir aquele <b>item</b> ao terminar uma <b>quest!</b><br/><br/>

                    A melhor motivação que garantirá a <b>diversão</b> em suas <b>aventuras</b> será sempre os <b>desafios.</b><br/><br/>

                    E é baseado exatamente nessa filosofia que se centra a construção desse projeto.<br/><br/>
                    Não se preocupe, caso você <b>não tenha muito tempo</b> pra desbravar todos os desafios mas mesmo assim queira se <b>divertir</b>, aqui também é o <b>seu lugar</b>. <br/><br/>
                    
                    Contamos com npc's como a <b>Mestra das Classes</b> que simplifica o processo de                     evolução.
                    Contúdo, ressaltamos que sempre preparamos <b>"surpresas a mais" para aqueles que optam por desbravar os desafios.</b>
        </TextSpam >
    );
};

const TextSpam = styled.span`
`;

export default TextHome1;